import { Box, Grid, Typography } from "@mui/material";
import BrowserNotSupportedIcon from "@mui/icons-material/BrowserNotSupported";
const UnSecuredPage = () => {
  return (
    <>
      <Box
        sx={{
          backgroundColor: "#f5f5f5",
          display: "flex",
          width: "100%",
          height: "100vh",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Grid container display={"flex"} justifyContent="center">
          <Grid
            item
            xs={12}
            display={"flex"}
            justifyContent="center"
            alignSelf={"center"}
            pt={3}
            px={6}
          >
            <BrowserNotSupportedIcon
              sx={{ fontSize: "100px", color: "#7f7c7c" }}
            />
          </Grid>
          <Grid
            item
            xs={12}
            display={"flex"}
            justifyContent="center"
            alignSelf={"center"}
            pt={3}
            px={6}
          >
            <Typography sx={{ color: "#7f7c7c", fontWeight: 600 }} variant="h6">
              INVALID
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};
export default UnSecuredPage;
